import { Link } from '@remix-run/react'
import {
	LuCalendarDays,
	LuMapPin,
	LuPlus,
	LuShoppingCart,
} from 'react-icons/lu'
import { addTrailingZeroes, truncateExcerpt } from '#app/utils/util.ts'
import { H3, Paragraph } from './typography'

function formatDateTime(datetime: string) {
	const date = new Date(datetime)
	return new Intl.DateTimeFormat('nl-NL', {
		weekday: 'short',
		day: '2-digit',
		month: '2-digit',
	}).format(date)
}

function formatLink(productType: string, handle: string) {
	switch (productType) {
		case 'Tasting':
			return `/wijn-proeverijen-castricum/${handle}`
		case 'Course':
			return `/wijn-cursussen/${handle}`
		default:
			return `/karakterbox/${handle}`
	}
}

export const ProductCard = ({ products }) => {
	if (products.length === 0) {
		return <div>No products found</div>
	}

	return products.map(
		({
			node: {
				title,
				description,
				id,
				featuredImage,
				metafields,
				handle,
				productType,
				priceRange: {
					maxVariantPrice: { amount, currencyCode },
				},
			},
		}) => {
			const filteredMetafields = metafields.filter(field => field !== null)
			const dateMetafield = filteredMetafields.find(k => k.key === 'date')
			const placeMetafield = filteredMetafields.find(k => k.key === 'plaats')

			return (
				<Link
					to={formatLink(productType, handle)}
					key={id}
					className="item min-w-[300px] max-w-[400px] border-[12px] border-solid border-white p-2 shadow-xl transition duration-300 hover:scale-[1.02] hover:cursor-pointer"
				>
					{/* <div> */}
					<H3 className="mb-4">{title}</H3>
					{featuredImage && (
						<img
							src={featuredImage.url}
							alt={featuredImage.altText}
							width={450}
							height={300}
						/>
					)}
					{dateMetafield && placeMetafield && (
						<div className="mt-2 flex flex-row items-center justify-between px-2">
							<div className="flex items-center gap-2 font-bold">
								<LuCalendarDays size={'24px'} color="orange" />
								<Paragraph className="capitalize">
									{formatDateTime(
										filteredMetafields.find(k => k.key === 'date').value,
									)}
								</Paragraph>
							</div>
							<div className="flex items-center gap-2 font-bold">
								<LuMapPin size={'24px'} color="orange" />
								<Paragraph>
									{filteredMetafields.find(k => k.key === 'plaats').value}
								</Paragraph>
							</div>
						</div>
					)}
					<Paragraph className="mx-4 my-3">
						{truncateExcerpt(description, 250)}
					</Paragraph>
					<div className="m-6 flex flex-row items-center justify-between">
						<H3 className="font-bold">{`€ ${addTrailingZeroes(amount)}`}</H3>
						<div className="flex items-center justify-between rounded-sm border border-secondary bg-secondary p-2 text-white">
							<LuPlus size={'24px'} />
							<LuShoppingCart size={'24px'} />
						</div>
					</div>
					{/* </div> */}
				</Link>
			)
		},
	)
}
